export default __webpack_public_path__ + "assets/images/8901f5ad65c8637c0d6b7956dffb3d22.png";